export default __webpack_public_path__ + "static/jeonghyun.an-095dace0f776f4cd3ce96cad27b64eea.jpeg";